import { useLocation, useNavigate, useNavigationType } from 'react-router'
import { SetupMFATOTP } from 'mfa'
import { withCenteredBaseWithMenu } from '../../components/Base'
import { useSetupMFATOTP } from '../../hooks/useSetupMFATOTP'
import { useSettings } from '../../hooks/useSettings'
import { useInitialization } from '../../contexts/Initialization'
import { getInitialSettings } from '../../utils/getInitialSettings'
import {
  LEARN_MORE_ABOUT_AUTHENTICATOR_APP,
  ROOT,
  SETTINGS_PAGE,
} from '../../constants/links'
import { APPLE_STORE_BADGE, GOOGLE_PLAY_BADGE } from '../../constants/images'

function SetupMFATOTPWrapper() {
  const navigate = useNavigate()
  const location = useLocation()
  const navigationType = useNavigationType()
  const { user } = useInitialization() || {}
  const isFromSettings = location.state?.isFromSettings ?? false
  const { step, isProcessing, errorCode, registrationData, prepare, finish } =
    useSetupMFATOTP({ isFromSettings })
  const { addMechanism } = useSettings(getInitialSettings(user))

  return (
    <SetupMFATOTP
      location={location}
      history={{ action: navigationType }}
      step={step}
      isFromSettings={isFromSettings}
      rootPath={ROOT}
      settingsPath={SETTINGS_PAGE}
      isProcessing={isProcessing}
      errorCode={errorCode}
      registrationData={registrationData}
      learnMoreAboutAuthenticatorAppUrl={LEARN_MORE_ABOUT_AUTHENTICATOR_APP}
      googlePlayBadgeUrl={GOOGLE_PLAY_BADGE}
      appleStoreBadgeUrl={APPLE_STORE_BADGE}
      onCancel={() => navigate(-1)}
      onPrepareRegistration={prepare}
      onFinishRegistration={async ({ registrationToken, otp }) => {
        const success = await finish({ registrationToken, otp })
        if (success) addMechanism('totp')
      }}
    />
  )
}

export default withCenteredBaseWithMenu(SetupMFATOTPWrapper)
